import qs from 'qs';

/**
 *  Generate Pagination links for SEO
 * @param {String} baseUrl
 * @param {Number} currentPage
 * @param {Object} location
 * @param {Number} nbHits
 * @param {Number} nbResultPerPage
 * @param {Number} offset
 */
export const generatePagination = ({
    baseUrl,
    currentPage,
    location,
    nbHits,
    nbResultPerPage,
    offset,
}) => {
    const paginations = [];
    const nbPages = Math.ceil((nbHits + offset) / nbResultPerPage);
    const filters = qs.parse(location?.search);
    if (currentPage > 1)
        paginations.push(
            `<link rel="prev" href="${baseUrl}${
                location.pathname
            }?${qs.stringify({
                ...filters,
                page: currentPage - 1,
            })}">`,
        );

    if (nbPages > currentPage)
        paginations.push(
            `<link rel="next" href="${baseUrl}${
                location.pathname
            }?${qs.stringify({
                ...filters,
                page: currentPage + 1,
            })}">`,
        );

    return paginations.join('');
};
export const generate = ({
    baseUrl = '',
    currentPage = '',
    location = { pathname: '', search: '' },
    nbHits = 0,
    nbResultPerPage = 60,
    offset = 0,
}) => {
    const pagination = generatePagination({
        baseUrl,
        currentPage,
        location,
        nbHits,
        nbResultPerPage,
        offset,
    });
    // More meta tags will come…
    return `
        ${pagination}
    `;
};

export default {
    generate,
};
